import React from 'react';
import styled from 'styled-components';
import Chevron from '../Chevron/Chevron';

export interface BackButtonProps {
  onClick?: () => void;
  ariaLabel?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  chevronColor?: 'black' | 'white';
}

type SizeProps = { $size: 'small' | 'medium' | 'large' };

const StyledBackButton = styled.button<SizeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 0 0 0 3px;
  aspect-ratio: 1 / 1;

  width: ${props =>
    props.$size === 'small' ? '5vw' :
    props.$size === 'medium' ? '7vw' : '11vw'
  };
  max-width: 38px;
  max-height: 38px;
  height: ${props =>
    props.$size === 'small' ? '5vw' :
    props.$size === 'medium' ? '7vw' : '11vw'
  };

  &:hover {
    background-color: #e8e8e8;
  }

  &:active {
    background-color: #dcdcdc;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  }
`;

const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  ariaLabel = 'Go back',
  size = 'medium',
  className,
  chevronColor = 'black',
}) => {
  const getChevronSize = () => {
    switch (size) {
      case 'small': return 6;
      case 'medium': return 8;
      case 'large': return 10;
      default: return 10;
    }
  };

  return (
    <StyledBackButton
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      $size={size}
      className={className}
    >
      <Chevron
        color={chevronColor}
        direction="left"
        strokeWidth={1.5}
        size={getChevronSize()}
      />
    </StyledBackButton>
  );
};

export default BackButton;
